module.exports = __webpack_public_path__ + "static/media/Best Part of Me.e7a01743.jpg";